import React from 'react';
import Text from '../Text';
import { cn } from 'lib/utils';

interface ErrorTextProps {
  text?: string | undefined;
  className?: string;
}

const ErrorText = ({ text, className }: ErrorTextProps) => {
  return <Text text={text} className={cn('text-red-500 text-xs mt-1', className)} />;
};

export default ErrorText;
